import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import {AngularTokenService} from '@lakshvairav/angular-token';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'ws-details',
  template: `
  <ul style="line-height: 30px" *ngIf="params && params.length > 0">
    <li class="data-overflow" *ngFor="let session of params" title="Session: {{session?.session}},  Role: {{session?.role}}">
      <div class="session-name">
        <b>Session</b>: {{ session?.session}}, 
      </div>
      <div class="role-name">
        <b>Role</b>: {{ session?.role}} 
      </div>
    </li>
  </ul>
  <span *ngIf="params && params.length == 0" class="data-overflow">N/A
  <button *ngIf="display_delete"
    (click)="invokeParentMethod()"
    class="reset-btn team_membership_reset_password icon-btn">
    <img [src]="deleteIconPath" alt="Delete User" style="width: 25px;height: 25px;margin-left: 5px"/>
  </button></span>
 `,
  styles: [
    `
    .data-overflow {
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom:0px !important;
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 45px;
    }

    .session-name, .role-name {
      max-width: 49%;
      min-width: 49%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
    }

    .role-name {
      margin-left: 5px;
    }
    `,
  ],
})
export class WorksessionDetailsComponent implements ICellRendererAngularComp {
  public params: any;
  public user_params: any;
  public current_user_id;
  public display_delete = false;
  public deleteIconPath: string;

  constructor(private _tokenService: AngularTokenService, private sanitizer: DomSanitizer) {
    this.current_user_id = this._tokenService.currentUserData.id;
    this.deleteIconPath = 'assets/images/delete-user.svg';
  }

  agInit(params: any): void {
    this.user_params = params;
    if (params && params.data && params.data.sessions_enrolled) { 
      this.display_delete = (this.current_user_id == this.user_params.data.id) ? false : true
      this.params = eval(JSON.parse(params.data.sessions_enrolled));
      this.params = this.convertToList(this.params);
    }
  }

  public invokeParentMethod() {
    this.user_params.context.componentParent.invokeDeleteUser(this.user_params.data);
  }

  refresh(): boolean {
    return false;
  }

  convertToList(items:any){
    const list = [];
    if (items.length > 0){
      items.forEach(element => {
        const sessionInfo = {};
        sessionInfo['role'] = element[0];
        sessionInfo['session'] = element[1];
        list.push(sessionInfo);
      });
    }
    return list;
  }

}